import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(main)/layout.tsx");
